module.exports = __webpack_public_path__ + "static/media/img-reason-deal.82314de2.png";